import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:stretch;}.ssr-plugin'
import '.a8{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dd{background:var(--palette-white);}.ssr-plugin'
import '.b5{flex-grow:1;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.ak{max-width:77.5rem;}.ssr-plugin'
import '.ew{justify-content:stretch;}.ssr-plugin'
import '.c0{position:sticky;}.ssr-plugin'
import '.bl{top:0px;}.ssr-plugin'
import '.c1{z-index:10;}.ssr-plugin'
import '.ex{padding-block:1rem;}.ssr-plugin'
import '.ey{height:3rem;}.ssr-plugin'
import '.b8{justify-content:space-between;}.ssr-plugin'
import '.ba{flex-wrap:wrap;}.ssr-plugin'
import '.ez{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.dx{margin-top:2rem;}.ssr-plugin'
import '.f0{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d t a8 e dd"
      >
        <div className="b5 d a7 a8 e"
        >
          <div className="ak d e ew c0 bl c1 dd"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ex ey d b8 a7 ba"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ez d e t dx f0 ak"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
